import { env } from "../../env";
import { handleExceptionMessage } from "../../helpers/handleExceptionMessage";
import { instance } from "../axiosInstance";
import {
  AssetDto,
  AssetsClient,
  ChangeAssetStateRequest,
  GetAllUtilExecsQueryDto,
  GetNestedAssetsQueryDto,
} from "../httpService";

const http = new AssetsClient(env.REACT_APP_MES_API_URL, instance);

export const getAllAssets = async (
  name?: string,
  showAll?: boolean,
  throwError: boolean = true
): Promise<Array<AssetDto> | undefined> => {
  try {
    const result = await http.getAllAssets(name, showAll);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const getAssetsUtilizationExecs = async (
  throwError: boolean = true
): Promise<Array<GetAllUtilExecsQueryDto> | undefined> => {
  try {
    const result = await http.getAllUtilExecs();
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const getAllNestedAssets = async (
  showAll?: boolean,
  throwError: boolean = true
): Promise<Array<GetNestedAssetsQueryDto> | undefined> => {
  try {
    const result = await http.getNestedAssets(showAll);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const changeAssetUtilizationState = async (
  assetId: string,
  utilRawId: string,
  comment: string | null,
  throwError: boolean = true
): Promise<void> => {
  try {
    const request = new ChangeAssetStateRequest({ utilRawId, comment });
    await http.changeAssetState(assetId, request);
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};
